import { render, staticRenderFns } from "./DeliverableCard.vue?vue&type=template&id=4de81a5b&scoped=true&"
import script from "./DeliverableCard.vue?vue&type=script&lang=js&"
export * from "./DeliverableCard.vue?vue&type=script&lang=js&"
import style0 from "./DeliverableCard.vue?vue&type=style&index=0&id=4de81a5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de81a5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4de81a5b')) {
      api.createRecord('4de81a5b', component.options)
    } else {
      api.reload('4de81a5b', component.options)
    }
    module.hot.accept("./DeliverableCard.vue?vue&type=template&id=4de81a5b&scoped=true&", function () {
      api.rerender('4de81a5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/DeliverableCard.vue"
export default component.exports